import { render, staticRenderFns } from "./PackagesView.vue?vue&type=template&id=2cc7b5f3&lang=pug"
import script from "./PackagesView.vue?vue&type=script&lang=js"
export * from "./PackagesView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports